import React from 'react';
import LeftNavArrow from '@/components/svg/LeftNavArrow';
import type { ForwardedRef } from 'react';

export enum ArrowDirection {
  left = 'rotate-0',
  right = 'rotate-180',
  up = 'rotate-90',
  down = '-rotate-90',
}

export enum ArrowButtonStyle {
  default = 'flex rounded-full w-10 h-10 bg-white active:bg-primary-pressed',
  dark = 'flex rounded-full w-10 h-10 font-white bg-primary-main active:bg-primary-pressed',
  border = 'flex rounded-full w-10 h-10 border-primary-main border-[1px] bg-white',
}

interface ArrowButtonProps {
  direction?: ArrowDirection;
  classes?: string;
  style?: ArrowButtonStyle;
}

const ArrowButton = React.forwardRef<HTMLButtonElement, ArrowButtonProps>(
  (
    {
      direction = ArrowDirection.left,
      classes,
      style = ArrowButtonStyle.default,
    },
    ref: ForwardedRef<HTMLButtonElement>
  ) => {
    return (
      <button ref={ref} className={`${style} flex-shrink-0`}>
        <div className="flex w-full place-content-center items-center self-center">
          <div className={direction}>
            <LeftNavArrow
              classes={classes}
              fill={style === ArrowButtonStyle.dark ? '#fff' : '#8490FF'}
            />
          </div>
        </div>
      </button>
    );
  }
);

ArrowButton.displayName = 'ArrowButton';

export default ArrowButton;
